import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import ManualBillingModal from 'components/bill/ManualBillingModal';
import ToolbarButton from 'components/layout/ToolbarButton';
import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Icon } from 'semantic-ui-react';
import { BillStatus } from 'ts-types/api.enums';
import { ConsultationDto, TreatmentDto } from 'ts-types/api.types';

interface Props extends AuthConsumerRenderProps, MessageSourceProps {
  currentTreatment?: TreatmentDto,
  currentConsultations: Array<ConsultationDto>,
  actionsToolbar?: boolean,
}

interface State {
  billModalOpen: boolean
}

class BillDetailsToolbarButton extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      billModalOpen: false
    }
  }

  toggleBillModal = () => {
    this.setState(({billModalOpen}: State) => ({
      billModalOpen: !billModalOpen
    }))
  };

  render(): React.ReactNode {

    const {
      getMessage,
      getMandate,
      currentTreatment,
      currentConsultations,
      actionsToolbar = false
    } = this.props;

    const selectedMandate = getMandate();

    const {billModalOpen} = this.state;

    const openConsultations = currentConsultations.filter(
        consultation => consultation.billStatus == BillStatus.OPEN);

    const actionToolbarButtonStyle = {padding: '0', paddingRight: '1rem'};

    const toolbarButtonStyle = {padding: '5px 7px'};

    return (
        <React.Fragment>
          <ToolbarButton iconName="file alternate outline"
                         iconSize="large"
                         toolbarButtonStyle={actionsToolbar ? actionToolbarButtonStyle : toolbarButtonStyle}
                         disabled={
                             !currentTreatment
                             || !currentConsultations
                             || currentConsultations.length == 0
                             || currentTreatment.mandateId !== selectedMandate
                             || (BillStatus.BILL == currentTreatment.billStatus && openConsultations.length == 0)
                         }
                         onClick={this.toggleBillModal}
                         dataTooltip={getMessage("invoice")}
                         customTrigger={(
                             <Icon.Group size="large">
                               <Icon name="file alternate outline"/>
                               <Icon corner="top right" name="magnify" color="grey"/>
                             </Icon.Group>
                         )}
          />
          {
              currentTreatment && billModalOpen &&
              <ManualBillingModal
                  modalOpen={billModalOpen}
                  onCloseModal={this.toggleBillModal}
                  treatmentId={currentTreatment.id}
              />
          }
        </React.Fragment>
    );
  }
}

export default withMessages(withAuthContext(BillDetailsToolbarButton));
